import { React, forwardRef } from 'react';
import {
  Grid,
  Card,
  Box,
  Skeleton,
  Stack,
  CardMedia,
  CardContent,
  useMediaQuery,
  Link,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import getConfig from 'next/config';
import styles from './styles';
import priceFormatter from '../../../util/priceFormatter';

const { publicRuntimeConfig } = getConfig();

const EirDeviceCard = forwardRef(({ device, loading, isPrepayHandset }, ref) => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid
      item
      xs={6}
      sm={6}
      md={4}
      lg={3}
      sx={{ cursor: 'pointer', p: 1 }}
      ref={ref}
      tabIndex={-1}
      style={{ outline: 'none' }}
    >
      <Link
        href={
          isPrepayHandset
            ? `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/prepay/handset/${device.slug}`
            : `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/handset/${device.slug}`
        }
        sx={{ ...styles(theme).deviceMainDiv }}
      >
        <Card sx={styles(theme).deviceCard}>
          {sm && device.outOfStock ? (
            <Typography variant='tooltip' sx={styles(theme).offerHeader}>
              Out of stock
            </Typography>
          ) : (
            ''
          )}
          {sm && !device.outOfStock && device?.flash?.description && device?.flash?.color && (
            <Typography
              variant='tooltip'
              style={{ backgroundColor: device?.flash?.color }}
              sx={styles(theme).offerHeader}
            >
              {device?.flash?.description}
            </Typography>
          )}
          <Stack
            direction={sm ? 'column' : 'row'}
            alignItems='center'
            justifyContent='center'
            sx={{ textAlign: 'center' }}
          >
            {loading ? (
              <>
                {/* <Skeleton
                  variant='rectangular'
                  sx={{ m: '0 auto', height: { xs: 90 }, width: { xs: 47 } }}
                /> */}
                <Skeleton height={24} width='50%' sx={{ m: '1rem auto 0' }} />
                {/* <Skeleton height={16} width='60%' sx={{ m: 'auto' }} />
                <Skeleton height={24} width='20%' sx={{ m: '1rem auto 0' }} /> */}
              </>
            ) : (
              <>
                <CardMedia
                  component='img'
                  alt={device.imageAltText}
                  src={device.image ? device.image : '/test/phone0.png'}
                  sx={styles(theme).deviceImage}
                  direction='row'
                  alignItems='center'
                />
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <CardContent sx={styles(theme).cardContent}>
                    {!sm && (
                      <Stack
                        direction='row'
                        justifyContent='flex-end'
                        alignItems='stretch'
                        sx={styles(theme).stockContainer}
                      >
                        {device.outOfStock && (
                          <Typography variant='tooltip' sx={styles(theme).stockLabel}>
                            {' '}
                            Out of Stock
                          </Typography>
                        )}
                      </Stack>
                    )}
                    {!sm && (
                      <Stack
                        direction='row'
                        justifyContent='flex-end'
                        alignItems='stretch'
                        sx={styles(theme).stockContainer}
                      >
                        {!device.outOfStock &&
                          device?.flash?.description &&
                          device?.flash?.color && (
                            <Typography
                              variant='tooltip'
                              style={{ backgroundColor: device?.flash?.color }}
                              sx={styles(theme).flashStockLabel}
                            >
                              {device?.flash?.description}
                            </Typography>
                          )}
                      </Stack>
                    )}
                    <Stack alignItems={sm ? 'center' : 'flex-start'}>
                      <Typography component='p' variant='subtitle2' sx={styles(theme).brandName}>
                        {device.manufacturer}
                      </Typography>
                      <Typography variant='body1' sx={styles(theme).modelName}>
                        {device.model}
                      </Typography>
                      <Typography variant='body1' sx={styles(theme).priceText}>
                        From&nbsp;
                        <Typography component='p' variant='subtitle3' sx={styles(theme).price}>
                          {device.price > 0 ? priceFormatter(parseFloat(device.price)) : 'Free'}
                        </Typography>
                      </Typography>
                    </Stack>
                  </CardContent>
                </Box>
              </>
            )}
          </Stack>
        </Card>
      </Link>
      {/* </Paper> */}
    </Grid>
  );
});

export default EirDeviceCard;
